import './App.css';
import { Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import UpperNav from './components/UpperNav';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import AboutUs from './components/About';
import WhatYouGet from './components/WhatYouGet';
import ServiceDetail from './components/ServiceDetail';
import Faqs from './components/Faqs';
import ContactUs from './components/ContactUs';
import Footer from './components/Footer';
import AboutPage from './components/pages/AboutPage';
import ServicesPage from './components/pages/ServicesPage';
import OurWorkPage from './components/pages/OurWorkPage';
import ContactPage from './components/pages/ContactPage';
import FaqPage from './components/pages/FaqPage';
import BlogsPage from './components/pages/BlogsPage';
import BlogDetailPage from './components/pages/BlogDetailPage';
import PolicyPage from './components/pages/PolicyPage';
import LicensesPage from './components/pages/LicensesPage';
import CertificatesPage from './components/pages/CertificatesPage';
import AdminLoginPage from './components/pages/AdminLoginPage';
import AdminDashboardPage from './components/pages/AdminDashboardPage';
import WhatsAppButton from './components/WhatsAppButton';

function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
}




function App() {
  return (
    <div className="App">
      <ScrollToTop />

      <Routes>
        <Route path="/" element={
          <>
          <UpperNav />
          <Navbar />
          <Hero />
          <Services />
          <AboutUs />
          <WhatYouGet />
          <Faqs />
          <ContactUs />
          <Footer />
          </>
        } />
        <Route path="/service/:id" element={
          <>
          <UpperNav />
          <Navbar />
          <ServiceDetail />
          <Footer />
          </>
        } />

        <Route path="/about" element={
          <>
          <UpperNav />
          <Navbar />
          <AboutPage />
          <Footer />
          </>
        } />

        <Route path="/services" element={
          <>
          <UpperNav />
          <Navbar />
          <ServicesPage />
          <Footer />
          </>
        } />

        <Route path="/our-work" element={
          <>
          <UpperNav />
          <Navbar />
          <OurWorkPage />
          <Footer />
          </>
        } />

        <Route path="/contact" element={
          <>
          <UpperNav />
          <Navbar />
          <ContactPage />
          <Footer />
          </>
        } />

        <Route path="/faq" element={
          <>
          <UpperNav />
          <Navbar />
          <FaqPage />
          <Footer />
          </>
        } />

        <Route path="/blogs" element={
          <>
          <UpperNav />
          <Navbar />
          <BlogsPage />
          <Footer />
          </>
        } />

        <Route path="/blogs/:slug" element={
          <>
          <UpperNav />
          <Navbar />
          <BlogDetailPage />
          <Footer />
          </>
        } />

        <Route path="/policy" element={
          <>
          <UpperNav />
          <Navbar />
          <PolicyPage />
          <Footer />
          </>
        } />

        <Route path="/licenses" element={
          <>
          <UpperNav />
          <Navbar />
          <LicensesPage />
          <Footer />
          </>
        } />

        <Route path="/certificates" element={
          <>
          <UpperNav />
          <Navbar />
          <CertificatesPage />
          <Footer />
          </>
        } />

        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
      </Routes>
      <WhatsAppButton />
    </div>
  );
}

export default App;
